import { useNavigate } from "react-router-dom";
import CircleButton from "../../atoms/circleButton/circleButton";
import OrbitPlanetDecoration from "../../atoms/orbitPlanetDecoration";
import Text from "../../atoms/text/text";
import "./homeCircle.scss";
const HomeCircle = ({ imgSrc, data }) => {
  const navigateTo = useNavigate();
  return (
    <>
      <div className="home-circle__main-container">
        <Text fontWeight={400} type={"h"} textSize={4}>
          {data.subtitle}
        </Text>
        <Text fontWeight={400} type={"h"} textSize={6}>
          {data.title}
        </Text>
        <div className="home-circle__description-container">
          <Text fontWeight={400} type={"h"} textSize={3}>
            {data.introductionText}
          </Text>
          <Text fontWeight={100} type={"h"} textSize={2}>
            {data.description}
          </Text>
        </div>

        <div className="home-circle__button">
          <CircleButton
            textSize={3}
            value="Entrar"
            handle={() => navigateTo(`/menu`)}
          />
        </div>

        <OrbitPlanetDecoration rotationZ="-150Deg" type={1} />
        <OrbitPlanetDecoration rotationZ="45Deg" type={2} />
        <OrbitPlanetDecoration rotationZ="135Deg" type={3} />
      </div>
      <img
        className="home-circle__bg-img"
        src={imgSrc}
        alt="Panorámica de la sede La Paz"
      />
    </>
  );
};

export default HomeCircle;
